/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var GovKoSfrIcon32Regular = forwardRef('GovKoSfrIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M17.817 3.176a1 1 0 0 1 .257 1.39l-2.75 4A1 1 0 0 1 14.5 9h-5a5.5 5.5 0 0 0 0 11h1.016a.879.879 0 0 0 .722-.379l7.88-11.38A2.88 2.88 0 0 1 21.483 7H22.5a7.5 7.5 0 0 1 0 15h-4.376l-4.552 6.57a1 1 0 0 1-1.644-1.14l4.85-7A1 1 0 0 1 17.6 20h4.9a5.5 5.5 0 0 0 0-11h-1.016a.879.879 0 0 0-.722.379l-7.88 11.38A2.879 2.879 0 0 1 10.517 22H9.5a7.5 7.5 0 0 1 0-15h4.474l2.452-3.567a1 1 0 0 1 1.39-.257Z" })));
});
